<template>
    <el-button type="success" plain  icon="el-icon-edit" v-on:click="clickEvent()">{{btnCon}}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'edit-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "修改"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// EditButton.vue?5ca81f59